import { memo } from 'react';
import { Text, Icon, RoundedCard } from '../../components';
import { content } from './content';
import "./AboutUs.scss";

function MemoComponent({ id }: { id: string }) {
  return (
    <section id={id} className="about-us">
      <div className="section-content">
        <Text variant="title2" weight={700}>
          {content.title}
        </Text>

        <div>
          <Text variant="content3" color="tertiary" align="center" className="mb-20">
            {content.paragraph1}
          </Text>

          <Text variant="content3" color="tertiary" align="center">
            {content.paragraph2}
          </Text>
        </div>

        <RoundedCard className="display-flex flex-wrap gap-20">
          <div className="left-side">
            <Icon
              className="icon-small-logo"
              size={24}
              color="tertiary"
              containerClassName="icon-blue-bg"
            />
            <Text variant="content1" weight={700} className="mt-20 mb-30">
              {content.card.title}
            </Text>
            <Text variant="content3" color="tertiary">
              {content.card.paragraph1}
            </Text>
          </div>

          <div className="right-side display-flex align-center justify-center">
            <Icon className="icon-big-logo" size={200} color="secondary"/>
          </div>
        </RoundedCard>
      </div>
    </section>
  )
};

export const AboutUs = memo(MemoComponent)